import React from 'react';
import { Player } from '../classes/Player';
import { cutText } from '../utils/TextsUtils';

interface RemovePlayerDialogInterface {
    players: Player[];
    playerId: number;
    closeDialog: any;
    handleRemovePlayer: any;
};

function RemovePlayerDialog({players, playerId, closeDialog, handleRemovePlayer}: RemovePlayerDialogInterface) {
    const closeIcon = require("../images/close.png");

    const handleClose = () => {
        closeDialog()
    }

    const handleClickRemovePlayer = async (idx: number) => {
        handleRemovePlayer(idx)
    }

    return (
        <div className="removePlayerDialogWrapper">
            <div className="dialogTop">
                <div className="dialogCloseWrapper" tabIndex={0} onClick={handleClose} onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        handleClose();
                    }
                }}>
                    <img className="dialogCloseIcon" src={closeIcon} alt="close"/>
                </div>
            </div>
            <div className="removePlayerDialogBottom">
                <div className="removePlayerDialogTitle">Remove a player?</div>
                <div className="removePlayerDialogSubtitle">Select a player to remove:</div>
                <div className="removePlayerPlayersWrapper">
                    {players.map((player, idx) => 
                        player.id !== playerId && <div className="removePlayerImageAndName" tabIndex={0} onClick={() => handleClickRemovePlayer(idx)} onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                handleClickRemovePlayer(idx);
                            }
                        }}>
                            <img className="removePlayerImage" src={require("../images/avatars/" + player.image + ".png")} alt="player avatar"/>
                            <div className="removePlayerName">{cutText(player.name, 15)}</div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default RemovePlayerDialog;